import React, {Fragment} from 'react'
import PropTypes from "prop-types";

const EmptyBanner = React.forwardRef(({className = '', children, items, message, icon, imageSrc}, ref) => {
    if (items && TB.isArray(items) && items.length > 0) {
        return (
            <Fragment ref={ref}>
                {children}
            </Fragment>
        )
    }
    try {
        if (typeof message === 'string') {
            message = TB.tryTrans(message);
        }
    } catch {
    }

    return (
        <div ref={ref} className={"feedback-banner " + className} style={{color: 'rgba(50, 60, 71, 0.4)'}}>

            {imageSrc ? <img src={imageSrc}/> : <i className={icon}/>}

            <p className="mt-3">
                {message}
            </p>
        </div>
    );
})

EmptyBanner.defaultProps = {
    icon: 'fa fa-folder-open',
    message: 'No Results Found.',
}

EmptyBanner.propTypes = {
    items: PropTypes.any,
    icon: PropTypes.string,
    message: PropTypes.any,
    imageSrc: PropTypes.string,
};

export default EmptyBanner